import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApplicationInfoModel } from 'app/models/application-info.model';

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html'
})
export class ConfirmDeleteDialogComponent {
  
  constructor(
     protected dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,
     @Inject(MAT_DIALOG_DATA) public data: ApplicationInfoModel
    )
     {}


  get formType() : string {
     return this.data.formType;
  }

  closeAndConfirmDialog () {
    this.dialogRef.close(`yes`);
  }

  closeAndNotConfirmDialog() {
    this.dialogRef.close(`no`);
  }

}
